import React from "react";

// React Components
import NoAuth from "../no-auth";

// Helpers
import Overview from "./overview";
import Main from "./main";
import Features from "./features";
import { Pricing } from "./pricing";
import Solutions from "./Products";
import Testimonials from './Testimonials';
import CallToAction from './CallToAction';
import { useTranslation } from "react-i18next";

const HomeContent = () => (
  <>
    <Main />
    <Overview />
    <Solutions />
    <Features />
    <Pricing />
{/*     <Testimonials />
    <CallToAction />  */}
  </>
);

const Home = () => {
  const { t } = useTranslation();
  return <NoAuth component={HomeContent} title={t('home.title') || "Home"} />;
};

export default Home;
